<template>
	<div>
	<order-banner :ch = "orderType.label" :en = "orderType.tgt.tgt" :index="imgSort"></order-banner>
	
	<div class = 'index_order_list page_padding'>
				 <order-box :imgSort = "imgSort" :info = "item" v-for = "(item,index) in list" :key = "index"></order-box>
				<!-- <img :src = "imgSrc(orderType.value)"/> -->
				<img @click =  "searchTopOrderType(orderType)" class = "more_img" v-if = "imgSort==0" src = "../../assets/更多商业服务.png"/>
				<img @click =  "searchTopOrderType(orderType)" class = "more_img" v-if = "imgSort==1" src = "../../assets/更多资本服务.png"/>
				<img @click =  "searchTopOrderType(orderType)" class = "more_img" v-if = "imgSort==2" src = "../../assets/更多开发类.png"/>
				<img @click =  "searchTopOrderType(orderType)" class = "more_img" v-if = "imgSort==3" src = "../../assets/更多设计类.png"/>
				<img @click =  "searchTopOrderType(orderType)" class = "more_img" v-if = "imgSort==4" src = "../../assets/更多资本服务.png"/>
			
	</div>
	</div>
</template>

<script>
	
	import orderBanner from '../orderBanner/orderBanner.vue'
	import orderBox from '../orderBox/orderBox.vue'
	import {queryYumiOrder,queryTopFwlxYumiOrder} from '../../api/cus.js'
	import {searchOrderType,searchTopOrderType} from '../../utils/index.js'
	
	export default{
		components:{
			orderBanner,
			orderBox
		},
		
		props:{
			
			orderType:Object,
			imgSort:Number
			
		},
		data(){
			
			return {
				list:[],
				
			}
			
		},
		created() {
			this.$nextTick(()=>{
				
				console.log('[orderType]',this.orderType);
				 // page: 0
				 // size: 10
				 // sort: createDateTime,desc
				 // orderName: a
				 
				 let params = {
					 page: 0,
					 size: 5,
					 sort: "createDateTime,desc",
					 topFwlx: this.orderType.value
					 }
				 
				queryTopFwlxYumiOrder(params).then(res=>{
					
					this.list = res.content
					
				})
			})
		},
		methods:{
			searchTopOrderType,
			searchOrderType,
			
			
		}
		
		
	}
	
	
</script>

<style>
	.more_img{
		
		width: 25vw;
		height: 13.229vw;
		
	}
	.index_order_list{
			  background-color: #EFF4F9;
			  display: grid;
			  grid-template-columns: 25vw 25vw 25vw;
			  grid-template-rows: 13.021vw 13.021vw;
			  grid-gap: 1.771vw;
			  
			  
	}
</style>
